import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

import type { UserData } from "entities/user/types";

type UserState = { data?: UserData };

const initialState: UserState = {};

export const userSlice = createSlice({
  initialState: initialState,
  name: "user",
  reducers: {
    reset: () => initialState,
    setUser: (state, action: PayloadAction<UserData>) => {
      state.data = action.payload;
      state.data.photo_url = `${action.payload.photo_url}?salt=${new Date().getTime()}`;
    },
    setNotificationsEmail: (state, action: PayloadAction<boolean>) => {
      if (state.data !== undefined) state.data.notifications.email = action.payload;
    },
  },
});
